import { $router } from "../../stores/router.ts";

export const getCurrentGraphId = (): null | string => {
  const route = $router.get();

  return route?.route === "graph" && "id" in route.params
    ? route.params.id
    : null;
};
